import React from 'react';
var VeltCommentPin = function (props) {
    var children = props.children, annotationId = props.annotationId;
    return (React.createElement("velt-comment-pin", { "annotation-id": annotationId }, children));
};
export default VeltCommentPin;
